////////LIBRARY/////////
import update from 'immutability-helper'
import { cloneDeep, find, forEach, reject, findIndex } from 'lodash'
///////COMPONENTS///////
import extendUpdate from '../../helpers/extendUpdate'
import ActionsTypes from '../../constants/ActionsTypes'

extendUpdate(update)

const usersManager = {
	[ActionsTypes.GET_ADMIN_USERS]: (state) =>
		update(state, {
			usersManager: {
				isLoading: {
					$set: true,
				},
				items: {
					$set: [],
				},
			},
			columns: {
				isSearchfieldUpdated: {
					$set: false,
				},
				currentDir: {
					$set: '',
				},
				currentColumn: {
					$set: '',
				},
			},
		}),
	[ActionsTypes.GET_ADMIN_USERS_SUCCESS]: (state, payload) => {
		let paging = cloneDeep(payload.adminUser.headerContent.contentPagined)
		let items = cloneDeep(payload.adminUser.headerContent.contentPagined.content)
		let filters = cloneDeep(payload.adminUser.headerParam.filters)

		return update(state, {
			usersManager: {
				isLoading: {
					$set: false,
				},
				paging: {
					$set: paging,
				},
				items: {
					$set: items,
				},
				header: {
					$set: filters,
				},
			},
		})
	},
	[ActionsTypes.GET_ADMIN_USERS_FAILURE]: (state, payload) =>
		update(state, {
			usersManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.GET_USER_DETAIL]: (state) =>
		update(state, {
			userDetail: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.GET_USER_DETAIL_SUCCESS]: (state, payload) => {
		return update(state, {
			userDetail: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: payload.userDetail,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.GET_USER_DETAIL_FAILURE]: (state, payload) =>
		update(state, {
			userDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.POST_USER_CREATE]: (state) =>
		update(state, {
			userDetail: {
				isLoading: {
					$set: true,
				},
				update: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.POST_USER_CREATE_SUCCESS]: (state, payload) => {
		const oldUser = cloneDeep(state.userDetail.items)
		const newUser = payload.user

		oldUser.userRole = find(oldUser.roles, { id: parseInt(newUser.idRole) })
		forEach(oldUser.kiosks, (elem) => {
			forEach(newUser.kiosks, (item) => {
				elem.isSelected = item === elem.id
			})
		})
		oldUser.firstName = newUser.firstName
		oldUser.lastName = newUser.lastName
		oldUser.phoneNumber = newUser.phoneNumber
		oldUser.userName = newUser.userName
		oldUser.email = newUser.email

		return update(state, {
			userDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
				items: {
					$set: oldUser,
				},
				update: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.POST_USER_CREATE_FAILURE]: (state, payload) => {
		return update(state, {
			userDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_USER_DETAIL]: (state, _payload) => {
		return update(state, {
			userDetail: {
				isLoading: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_USER_DETAIL_SUCCESS]: (state, payload) => {
		const user = payload.user
		const currentUser = cloneDeep(state.user.identity)

		// update current user if user selected is himself
		if (user.id === currentUser.id) {
			currentUser['firstName'] = user.firstName
			currentUser['lastName'] = user.lastName
			currentUser['email'] = user.email
			currentUser['phoneNumber'] = user.phoneNumber
			currentUser['preferedLanguage'] = user.preferedLanguage
			currentUser['userKiosks'] = user.userKiosks
			currentUser['kioskSelected'] = user.userKiosks[0].idKiosk
		}
		return update(state, {
			user: {
				identity: {
					$set: { ...currentUser },
				},
			},
			userDetail: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: user,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.UPDATE_USER_DETAIL_FAILURE]: (state, payload) =>
		update(state, {
			userDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),

	[ActionsTypes.DELETE_ADMIN_USER]: (state) =>
		update(state, {
			usersManager: {
				isLoading: {
					$set: true,
				},
			},
		}),
	[ActionsTypes.DELETE_ADMIN_USER_SUCCESS]: (state, payload) => {
		const newAdminUser = payload.adminUser
		let oldAdminUser = cloneDeep(state.usersManager.items)
		const scope = payload.scope
		const idUser = payload.idUser

		if (scope === 'delete') {
			oldAdminUser = reject(oldAdminUser, { id: idUser })
		}
		if (scope === 'disable') {
			const idxAdminUser = findIndex(oldAdminUser, { id: newAdminUser.id })
			oldAdminUser[idxAdminUser] = newAdminUser
		}

		return update(state, {
			usersManager: {
				isLoading: {
					$set: false,
				},
				items: {
					$set: [...oldAdminUser],
				},
				error: {
					$set: false,
				},
				deleteSuccess: {
					$set: true,
				},
			},
		})
	},
	[ActionsTypes.DELETE_ADMIN_USER_FAILURE]: (state, payload) => {
		return update(state, {
			usersManager: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		})
	},
	[ActionsTypes.USER_DETAIL_RESET_PASSWORD]: (state) =>
		update(state, {
			userDetail: {
				isLoading: {
					$set: true,
				},
				error: {
					$set: false,
				},
			},
		}),
	[ActionsTypes.USER_DETAIL_RESET_PASSWORD_SUCCESS]: (state) => {
		return update(state, {
			userDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: false,
				},
			},
		})
	},
	[ActionsTypes.USER_DETAIL_RESET_PASSWORD_FAILURE]: (state, payload) =>
		update(state, {
			userDetail: {
				isLoading: {
					$set: false,
				},
				error: {
					$set: payload.error,
				},
			},
		}),
	[ActionsTypes.RESET_USER_DETAIL]: (state) =>
		update(state, {
			userDetail: {
				items: {
					$set: [],
				},
			},
		}),
	[ActionsTypes.SET_USER_LOGIN]: (state, payload) => {
		return update(state, {
			usersManager: {
				userLogin: {
					$set: payload.userLogin,
				},
			},
		})
	},
	[ActionsTypes.RESET_DATA_USERS_MANAGER]: (state, _payload) => {
		return update(state, {
			usersManager: {
				isLoading: {
					$set: false,
				},
				userLogin: {
					$set: '',
				},
				error: {
					$set: false,
				},
				paging: {
					$set: {},
				},
				items: {
					$set: [],
				},
				header: {
					$set: {},
				},
				companyId: {
					$set: {},
				},
			},
		})
	},
}

export default usersManager
